// extracted by mini-css-extract-plugin
module.exports = {"edit-ranking-title":"edit-ranking-title-51e86f57139b6ce4bd975c0d745e5970","edit-ranking-button":"edit-ranking-button-3ce2b3698da01163a454de56a696da19"};